import { TextField, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type IProps = TextFieldProps & {
  name: string;
  label: string;
};

export const TextFieldInput = ({ name, label, ...rest }: IProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          label={label}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          {...field}
          {...rest}
        />
      )}
    />
  );
};
